import { render } from "./GradingDetailsDialog.vue?vue&type=template&id=685b532e&scoped=true"
import script from "./GradingDetailsDialog.vue?vue&type=script&lang=js"
export * from "./GradingDetailsDialog.vue?vue&type=script&lang=js"

import "./GradingDetailsDialog.vue?vue&type=style&index=0&id=685b532e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685b532e"]])

export default __exports__